<template>
  <dialogue-modal
    v-if="distributorToDelete"
    title="Are you sure you want to delete?"
    :message="distributorToDelete.reference"
    :close-popup="hideDeleteModal"
    :buttons="buttons"
  />
  <page-title pageTitle="Suppliers" title="All Suppliers" />

  <div class="row pb-4 gy-3 justify-content-between">
    <div class="col-sm-auto col-md">
      <router-link
        to="/distributors/new"
        class="btn btn-primary addtax-modal no-wrap"
      >
        <i class="las la-plus me-1"></i> Add New
      </router-link>
    </div>

    <div class="col-sm-auto col-md-8">
      <div class="search-box">
        <input
          type="text"
          class="form-control"
          id="searchMemberList"
          placeholder="Search for Result"
          v-model="searchQuery"
          @input="goToPage(1)"
        />
        <i class="las la-search search-icon"></i>
      </div>
    </div>

    <div class="col-sm-auto col-md">
      <div class="input-group">
        <label class="input-group-text" for="inputGroupSelect01">Show</label>
        <select
          class="form-select"
          id="resultsPerPage"
          v-model="resultsPerPage"
          @change="goToPage(1)"
        >
          <option
            v-for="option in resultsPerPageOptions"
            :key="option"
            :value="option"
          >
            {{ option }}
          </option>
        </select>
      </div>
    </div>
  </div>

  <div v-if="data && data.length > 0">
    <div class="row">
      <div class="col-xl-12">
        <div class="card">
          <div class="card-body">
            <table-component
              :headers="headers"
              :footer="footer"
              :data="formattedData"
              :actions="actions"
              :offset="(currentPage - 1) * resultsPerPage"
              @sort="goToPage"
            />
          </div>
        </div>
      </div>
    </div>
    <pagination-component
      :rows-loaded="data.length"
      :current-page="currentPage"
      :num-pages="numPages"
      :total-rows="totalRows"
      :go-to-page="goToPage"
    />
  </div>

  <div v-else class="row">
    <div class="col-xl-12">
      <div class="card">
        <LoadingModal v-if="loading" />
        <div v-else class="card-body">
          {{ error }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PageTitleComponent from "@/components/shared/PageTitle";
import TableComponent from "@/components/utils/Table";
import { SETTINGS } from "@/constants/config.js";
import { CONSTANTS } from "@/constants/constants.js";
import LoadingModalComponent from "@/components/utils/LoadingModal";
import PaginationComponent from "@/components/utils/paginationComponent";
import DialogueModal from "@/components/utils/modals/DialogueModal";

export default {
  name: "AllDistributorsView",
  components: {
    DialogueModal,
    PaginationComponent,
    LoadingModal: LoadingModalComponent,
    PageTitle: PageTitleComponent,
    TableComponent: TableComponent,
  },
  data() {
    return {
      searchQuery: "",
      resultsPerPage: SETTINGS.resultsPerPage,
      distributorToDelete: null,
    };
  },
  computed: {
    headers() {
      return CONSTANTS.DISTRIBUTORS_HEADERS;
    },
    data() {
      return this.$store.getters.allDistributors;
    },
    formattedData() {
      return this.$store.getters.allDistributors;
    },
    currentPage() {
      return this.$store.getters.distributorsCurrentPage;
    },
    numPages() {
      return this.$store.getters.distributorsNumPages;
    },
    totalRows() {
      return this.$store.getters.distributorsTotalRows;
    },
    resultsPerPageOptions() {
      const options = CONSTANTS.RESULTS_PER_PAGE_OPTIONS;
      if (!options.includes(this.resultsPerPage)) {
        options.unshift(this.resultsPerPage);
      }
      return options;
    },
    actions() {
      return {
        View: (distributor) => this.viewDistributor(distributor.id),
        Edit: (distributor) => this.editDistributor(distributor.id),
        Delete: (distributor) => this.showDeleteModal(distributor),
      };
    },
    error() {
      return this.$store.getters.distributorsError;
    },
    loading() {
      return this.$store.getters.distributorsLoading;
    },
    buttons() {
      return {
        Yes: {
          class: "btn-danger",
          function: () => this.deleteDistributor(),
        },
        No: {
          class: "btn-light px-3",
          function: () => this.hideDeleteModal(),
        },
      };
    },
  },
  methods: {
    async goToPage(page, sortBy = null) {
      let filter = {
        sortingList: sortBy,
        currentPage: page,
        resultsPerPage:
          this.resultsPerPage === "ALL" ? this.totalRows : this.resultsPerPage,
        searchQuery: this.searchQuery,
      };
      await this.$store.dispatch("getDistributors", filter);
    },
    viewDistributor(id) {
      this.$router.push("/distributors/" + id);
    },
    editDistributor(id) {
      this.$router.push("/distributors/edit/" + id);
    },
    showDeleteModal(distributor) {
      this.distributorToDelete = distributor;
    },
    async deleteDistributor() {
      if (this.distributorToDelete) {
        await this.$store.dispatch(
          "deleteDistributor",
          this.distributorToDelete.id
        );
        await this.goToPage(1);
        this.hideDeleteModal();
      } else {
        alert("There has been an error");
      }
    },
    hideDeleteModal() {
      this.distributorToDelete = null;
    },
  },
  async created() {
    let filter = {
      resultsPerPage: SETTINGS.resultsPerPage,
    };
    await this.$store.dispatch("getDistributors", filter);
  },
  async beforeUnmount() {
    await this.$store.dispatch("resetDistributor");
  },
};
</script>

<style scoped></style>
